<template>
  <router-view />
</template>

<script>
export default {
  name: "PortaisCassems",
};
</script>
